import React, { useEffect } from 'react';
import styles from './dimijs/src/lib/theme/base.module.scss';
import cn from 'classnames';

import {Routes, Route, useLocation} from 'react-router-dom';
import {FormRegister} from './pages/FormRegister';
import {FormLogin} from './pages/FormLogin';
import {Panel} from './pages/Panel';
import {Page} from './pages/Page';
import modalStyles from './dimijs/src/lib/components/Modal.module.scss';
import {Collections} from './pages/panel/Collections';
import {DataContext} from './dimijs/src/lib/utils/dataContext';
import {Users} from './pages/panel/Users';
import {useAnalytics} from './hooks/useAnalytics';
import {ThemeProvider, useTheme} from './ui/theme/ThemeContext';

// Analytics wrapper component
function AnalyticsWrapper({ children }) {
  const location = useLocation();
  const { trackPageView, trackNavigation } = useAnalytics();
  const prevLocation = React.useRef(location.pathname);

  useEffect(() => {
    // Track page views
    trackPageView(location.pathname);
    
    // Track navigation
    if (prevLocation.current !== location.pathname) {
      trackNavigation(prevLocation.current, location.pathname, 'programmatic');
      prevLocation.current = location.pathname;
    }
  }, [location.pathname, trackPageView, trackNavigation]);

  return <>{children}</>;
}

// Admin/Creator CSS variable overrides (purple theme)
const adminCssOverrides: React.CSSProperties = {
  '--primaryColor': 'rgb(152, 16, 250)',
  '--primaryAccentColor': '#7a0dc8',
  '--primaryLightColor': '#f3e8ff',
  '--primaryLighterColor': '#faf5ff',
  '--primaryDarkColor': '#8200db',
  '--headerBg': 'rgb(240, 233, 255)',
  '--gridHeaderBg': '#F9F5FF',
} as React.CSSProperties;

function ThemedRoot({ children }: { children: React.ReactNode }) {
  const { isAdminOrCreator } = useTheme();
  return (
    <div className={cn(styles.root)} style={isAdminOrCreator ? adminCssOverrides : undefined}>
      {children}
    </div>
  );
}

function App(props) {
  const MainRouter = props.MainRouter;
  return (
    <DataContext initProps={props.initProps} store={props.store}
      ssrDataCollector={props.ssrDataCollector}>
      <ThemeProvider>
        <MainRouter {...props.routerProps}>
          <AnalyticsWrapper>
            <ThemedRoot>
              <Routes>
                <Route path="/form" element={<FormRegister />} />
                <Route path="/login" element={<FormLogin />} />
                <Route path="/panel" element={<Panel />} />
                <Route path="/panel/collections" element={<Collections />} />
                <Route path="/panel/users" element={<Users />} />
                <Route path="/p/*" element={<Page />} />
                <Route path="/" element={<Page />} />
              </Routes>
              <div className={modalStyles.modalRoot} id={'modalRoot'}></div>
            </ThemedRoot>
          </AnalyticsWrapper>
        </MainRouter>
      </ThemeProvider>
    </DataContext>
  );
}

export default App;
